import request from '../../../core/wrappers/axios-wrapper';
import { StoreManagerPermissionCommand } from '../../../types/constants/apiUrls/storeManagerPermission/storeManagerPermissionCommand';
import { RequestType } from '../../../types/enums/request-enums';

// Body: yalnızca TargetApplicationUserId + Enabled (Store/Feature/Actor sunucuda)
const SetGrant = (params: {
    TargetApplicationUserId: number;
    Enabled: boolean;
}): Promise<any> =>
    request({
        url: StoreManagerPermissionCommand.SetGrant,
        method: RequestType.POST,
        data: params,
    });

const StoreManagerPermissionCommandService = {
    SetGrant,
};

export default StoreManagerPermissionCommandService;
